const getTitleByQuantity = (quantity: number): string => quantity > 1 ? ` (${quantity} шт.)` : '';

export default getTitleByQuantity;
